import "./index.css";
import App from "./App";
import i18n from "@/common/config/i18/i18n";
import { ThemeProvider } from "@/common/contexts/theme/theme-provider";
import { Toaster } from "@/components/ui/toaster";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import { featureToggleServiceInstance } from "@/common/config/FeatureToggleService";

const rootEl = document.getElementById("root");

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 1,
    },
  },
});

featureToggleServiceInstance.initialize()
  .then(() => console.log('Initialized'))
  .catch(error => console.error('Failed to initialize', error));

if (rootEl) {
  const root = ReactDOM.createRoot(rootEl);
  root.render(
    <ThemeProvider defaultTheme="system" storageKey="ui-theme">
      <QueryClientProvider client={queryClient}>
        <I18nextProvider i18n={i18n}>
          <App />
          <ReactQueryDevtools initialIsOpen={false} />
          <Toaster />
        </I18nextProvider>
        <Toaster />
      </QueryClientProvider>
    </ThemeProvider>,
  );
}
